import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';

const valueGetter = (params: ValueFormatterParams | ValueGetterParams) => (params?.node?.data?.is_subnational ? 'Subnational' : 'National');

export const DEFAULT_IS_SUBNATIONAL_COL_DEF: ColDef = {
  headerName: 'SUB/NAT',
  field: 'is_subnational',
  valueGetter,
  filterValueGetter: valueGetter,
};
